import { createColumnHelper } from '@tanstack/react-table';
import {
  AdminTokenUsageTotalTable,
  AdminTokenUsageTotalTableRow,
} from '@features/admin-token-usage/types';
import { Typography } from '@mui/material';

const columnHelper = createColumnHelper<AdminTokenUsageTotalTableRow>();

export const createAdminTokenUsageTotalTableColumns = (
  tableData: AdminTokenUsageTotalTable | null
) => {
  if (!tableData) return [];

  const columns: any = [
    columnHelper.accessor('name', {
      id: 'name',
      header: '',
      enableSorting: true,
      size: 200,
      enableResizing: false,
      cell: ({ row: { original } }) => {
        return <Typography variant="subtitle1">{original.name}</Typography>;
      },
    }),
    columnHelper.accessor('avg', {
      id: 'avg',
      header: 'AVG',
      enableSorting: true,
      size: 100,
      enableResizing: false,
      cell: ({ row: { original } }) => {
        return (
          <Typography variant="subtitle1">
            {original.formatFunction(original.avg)}
          </Typography>
        );
      },
    }),
    ...tableData.headers.map((month, index) =>
      columnHelper.accessor((row) => row.values[index], {
        id: `month-${index}`,
        header: month,
        enableSorting: true,
        size: 100,
        enableResizing: false,
        cell: ({ row: { original } }) => {
          return (
            <Typography variant="body1">
              {original.formatFunction(original.values[index])}
            </Typography>
          );
        },
      })
    ),
    columnHelper.accessor('total', {
      id: 'total',
      header: 'Total',
      enableSorting: true,
      size: 100,
      enableResizing: false,
      cell: ({ row: { original } }) => {
        return (
          <Typography variant="subtitle1">
            {original.formatFunction(original.total)}
          </Typography>
        );
      },
    }),
  ];

  return columns;
};
